import { LoadingComponent } from './loading.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';


@NgModule({
    declarations: [
        LoadingComponent,
    ],
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
    ],
    exports: [
        LoadingComponent,
    ],
})
export class DaveLoadingModule {}
